import React from 'react'
import PropTypes from 'prop-types'
import {Flex} from '@chakra-ui/react'

const WarrantyStepContainer = ({children}) => {
    return (
        <Flex direction="column" gap={6}>
            {children}
        </Flex>
    )
}

WarrantyStepContainer.propTypes = {
    children: PropTypes.node.isRequired
}

export default WarrantyStepContainer
